<template>
  <div class="" id="pageTop" style="padding:1rem 1rem 10rem">
    <div class="">
      <div class="col-12">
        <div class="row ">
            <div class="col-12 col-lg-3 ">
                
            </div>
            <div class="col-12 col-lg-6 ">
                <div class="row " v-if="!showForm">
                    <div class="col-12">
                        <div class="card card-body">
                            <p>Thank you for pre-registering for Rotary District 7030 PETS & Conference 2022.</p>
<p>Please be on the lookout for registration and event information by email, and remember to check out Facebook and Instagram for event updates as well.
We look forward to welcoming each and every one of you to Barbados in 2022.</p>
<p>Yours In Rotary,
<br/><strong>Conference Secretariat</strong></p>
<p>--------</p>
<p>Merci de vous être pré-inscrit au SFPE et à la Conférence 2022 du Rotary District 7030.</p>
<p>Soyez à l"affût des informations d"inscription et d"événements par e-mail, et n"oubliez pas de consulter Facebook et Instagram pour les mises à jour de l"événement.
    Nous sommes impatients d"accueillir chacun d"entre vous à la Barbade en 2022.
</p>
<p>Bien à vous au Rotary,
<br/><strong>Secrétariat de la Conférence</strong></p>
                            <button class="btn btn-primary my-4" @click="$router.push('/registrations')">
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row " v-if="showForm">
                    <div class="col-12">
                        <h5>Add New Registration</h5>
                    </div>
                    <div class="col-12 my-2">
                        <div class="alert alert-primary" v-html="confInfo.confregistrationmsg">
                            <!-- {{confInfo.confregistrationmsg}} -->
                        </div>
                    </div>
                    
                    <div class="col-12 my-3">
                        <label class="text-muted">Please select an option from below to continue.*</label>
                        <select class="form-control" v-model="registerType">
                            <option disabled selected value="0">Please choose</option>
                            <option value="1">I am registering myself</option>
                            <option value="2">I am registering a guest</option>
                        </select>
                    </div>
                </div>
                <div class="row" v-show="showForm && registerType!=0">
                    <div class="col-12 my-2">
                        <label class="text-muted">Event*</label>
                        <select class="form-control">
                            <option value="confId">{{confName}}</option>
                        </select>
                    </div>
                    <div class="col-12 my-2">
                        <label class="text-muted">Conference ticket*</label>
                        <select class="form-control" v-model="confticket">
                            <option disabled value="0">Please choose</option>
                            <option v-for="ticket in confTickets" :key="ticket.id" :value="{id: ticket.id, name: ticket.data.name, price: ticket.data.price} ">{{ticket.data.name}} {{ticket.data.price > 0 ? ` - ${ticket.data.price.toLocaleString("en-US", {style:"currency", currency:"USD"})}` : ""}}</option>
                        </select>
                    </div>
                    <div class="col-12 my-2" v-show="registerType==2">
                        <label class="text-muted">First name*</label>
                        <input type="text" class="form-control"  v-model="register.fname">
                    </div>
                    <div class="col-12 my-2" v-show="registerType==2">
                        <label class="text-muted">Last name*</label>
                        <input type="text" class="form-control" v-model="register.lname" >
                    </div>
                    <div class="col-12 my-2" v-show="registerType==2">
                        <label class="text-muted">Email address*</label>
                        <input type="text" class="form-control" v-model="register.email" >
                    </div>
                    <div class="col-12 my-2" v-show="registerType==2">
                        <label class="text-muted">Telephone contact*</label>
                        <input type="text" class="form-control" v-model="register.phone" >
                    </div>
                    <div class="col-12 my-2" v-show="registerType==2">
                        <label class="text-muted">Gender*</label>
                        <select class="form-control" v-model="register.gender">
                            <option disabled value="0" selected>Please choose</option>
                            <option>FEMALE</option> 
                            <option>MALE</option> 
                            <option>NON-BINARY</option> 
                        </select>
                    </div>
                    <div class="col-12 my-2" v-show="registerType==2">
                        <label class="text-muted">Country*</label>
                        <select class="form-control" v-model="register.country">
                            <option disabled value="0" selected>Please choose</option>
                            <option value="ANGUILLA">ANGUILLA</option>
                            <option value="ANTIGUA AND BARBUDA">ANTIGUA AND BARBUDA</option>
                            <option value="ARUBA">ARUBA</option>
                            <option value="BARBADOS">BARBADOS</option>
                            <option value="BONAIRE">BONAIRE</option>
                            <option value="CURACAO">CURAÇAO</option>
                            <option value="DOMNICA">DOMINICA</option>
                            <option value="FRENCH GUIANA">FRENCH GUIANA</option>
                            <option value="GRENADA">GRENADA</option>
                            <option value="GUADELOUPE">GUADELOUPE</option>
                            <option value="GUYANA">GUYANA</option>
                            <option value="JAMAICA">JAMAICA</option>
                            <option value="MARTINIQUE">MARTINIQUE</option>
                            <option value="MONTSERRAT">MONTSERRAT</option>
                            <option value="SAINT KITTS AND NEVIS">SAINT KITTS AND NEVIS</option>
                            <option value="SAINT LUCIA">SAINT LUCIA</option>
                            <option value="SAINT VINCENT AND THE GRENADINES">SAINT VINCENT AND THE GRENADINES</option>
                            <option value="SURINAME">SURINAME</option>
                            <option value="TRINIDAD AND TOBAGO">TRINIDAD AND TOBAGO</option>
                            <option disabled>------</option>
                            <option>OTHER</option>
                        </select>
                    </div>
                    
                    <div class="col-12 my-2">
                        <label class="text-muted">Club*</label>
                        <select class="form-control" v-model="register.club">
                            <option disabled value="0" selected>Please choose</option>
                            <option>Other</option>
                            <option>Not Aplicable</option>
                            <option disabled>--------------</option>
							<option v-show="confInfo.conftype=='rotary'" disabled>Rotary Clubs</option>
							<option v-show="confInfo.conftype=='rotary'" disabled>--------------</option>
                            <option v-show="confInfo.conftype=='rotary'"  data-type="Rotarian">RC Antigua</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Antigua Sundown</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Arima</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Aruba</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Barbados</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Barbados South</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Barbados West</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Basse Terre</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Basse Terre Fort Saint Charles</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Bequia</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Bonaire</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Cayenne</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Cayenne-Est</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Central Port of Spain</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Chaguanas</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Coeur Caraibes (Lamentin)</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Corriverton</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Curacao</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Demerara</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Diego Martin</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Dominica</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Felicity-Charlieville</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Fort-de-France</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Fort-de-France Ouest</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Fort-de-France Sud</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Francois</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Garden City (Guyana)</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Georgetown</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Georgetown Central</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Grande Terre Pointe Des Chateaux</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Grenada</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Grenada East</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Gros Islet</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Kourou</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Lamentin</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Liamuiga</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Maracas-St. Joseph</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Maraval</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Marie-Galante</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Montserrat</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC New Amsterdam</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Paramaribo</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Paramaribo Central</option>
							<option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Paramaribo Quota</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Paramaribo Residence</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Penal</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Piarco</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Point Fortin</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Pointe-A-Pierre</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Pointe-a-Pitre Doyen</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Pointe-a-Pitre Est</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Pointe-a-Pitre Fleur d"Epee</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Pointe-a-Pitre Jarry</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Port of Spain</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Port of Spain West</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Portsmouth</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Princes Town</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Remire Montjoly</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Saint Pierre</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Saint-Laurent Mana Ouest Guyanais</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC San Fernando</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC San Fernando-South</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC San Juan</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Sangre Grande</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Schoelcher</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Southwest-Tobago</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC St. Augustine</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC St. Augustine West</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC St. Kitts</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC St. Lucia</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC St. Vincent</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC St. Vincent South</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Stabroek-Georgetown</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Tobago</option>
                            <option  v-show="confInfo.conftype=='rotary'" data-type="Rotarian">RC Willemstad</option>        
                            <option v-show="confInfo.conftype=='rotary'" disabled>--------------</option>
							<option v-show="confInfo.conftype=='rotary'" disabled>Rotaract Clubs</option>
							<option v-show="confInfo.conftype=='rotary'" disabled>--------------</option>
							<option data-type="Rotaractor">RTC Antigua</option>
                            <option data-type="Rotaractor">RTC Arima</option>
                            <option data-type="Rotaractor">RTC Arima West</option>
                            <option data-type="Rotaractor">RTC Aruba</option>
                            <option data-type="Rotaractor">RTC Aruba</option>
                            <option data-type="Rotaractor">RTC Barbados</option>
                            <option data-type="Rotaractor">RTC Barbados</option>
                            <option data-type="Rotaractor">RTC Barbados West</option>
                            <option data-type="Rotaractor">RTC Cayenne</option>
                            <option data-type="Rotaractor">RTC Central Port of Spain</option>
                            <option data-type="Rotaractor">RTC Chaguanas</option>
                            <option data-type="Rotaractor">RTC Curacao</option>
                            <option data-type="Rotaractor">RTC F.R.E.S.H.</option>
                            <option data-type="Rotaractor">RTC Felicity-Charlieville</option>
                            <option data-type="Rotaractor">RTC Fort-de-France</option>
                            <option data-type="Rotaractor">RTC Genesis of Suriname</option>
                            <option data-type="Rotaractor">RTC Georgetown</option>
                            <option data-type="Rotaractor">RTC Georgetown Central</option>
                            <option data-type="Rotaractor">RTC Grenada</option>
                            <option data-type="Rotaractor">RTC Grenada-East</option>
                            <option data-type="Rotaractor">RTC Gros Islet</option>
                            <option data-type="Rotaractor">RTC Gros Islet</option>
                            <option data-type="Rotaractor">RTC Ile de Cayenne</option>
                            <option data-type="Rotaractor">RTC Kingstown</option>
                            <option data-type="Rotaractor">RTC Kourou</option>
                            <option data-type="Rotaractor">RTC L.E.P. Francois</option>
                            <option data-type="Rotaractor">RTC Lamentin</option>
                            <option data-type="Rotaractor">RTC Linden</option>
                            <option data-type="Rotaractor">RTC Maraval</option>
                            <option data-type="Rotaractor">RTC Marie-Galante</option>
                            <option data-type="Rotaractor">RTC Montserrat</option>
                            <option data-type="Rotaractor">RTC Mount Hope</option>
                            <option data-type="Rotaractor">RTC Nevis</option>
                            <option data-type="Rotaractor">RTC New Amsterdam</option>
                            <option data-type="Rotaractor">RTC Paramaribo</option>
                            <option data-type="Rotaractor">RTC Penal</option>
                            <option data-type="Rotaractor">RTC Piarco</option>
                            <option data-type="Rotaractor">RTC Piarco (U.W.I)</option>
                            <option data-type="Rotaractor">RTC Point Fortin</option>
                            <option data-type="Rotaractor">RTC Pointe-a-Pitre</option>
                            <option data-type="Rotaractor">RTC Pointe-a-Pitre</option>
                            <option data-type="Rotaractor">RTC Ponte a Pierre</option>
                            <option data-type="Rotaractor">RTC Port Of Spain</option>
                            <option data-type="Rotaractor">RTC Port of Spain West</option>
                            <option data-type="Rotaractor">RTC Roseau</option>
                            <option data-type="Rotaractor">RTC Saint Pierre</option>
                            <option data-type="Rotaractor">RTC Saint Pierre</option>
                            <option data-type="Rotaractor">RTC San Fernando</option>
                            <option data-type="Rotaractor">RTC San Fernando</option>
                            <option data-type="Rotaractor">RTC San Fernando South</option>
                            <option data-type="Rotaractor">RTC Sangre Grande</option>
                            <option data-type="Rotaractor">RTC South Barbados</option>
                            <option data-type="Rotaractor">RTC South St. Lucia</option>
                            <option data-type="Rotaractor">RTC Southwest Tobago</option>
                            <option data-type="Rotaractor">RTC St. Augustine</option>
                            <option data-type="Rotaractor">RTC St. Augustine West</option>
                            <option data-type="Rotaractor">RTC St. Kitts</option>
                            <option data-type="Rotaractor">RTC St. Lucia</option>
                            <option data-type="Rotaractor">RTC Stabroek</option>
                            <option data-type="Rotaractor">RTC University of Guyana</option>
                            <option data-type="Rotaractor">RTC UWI Cave Hill Barbados</option>
                            <option data-type="Rotaractor">RTC UWI Cavehill</option>
                        </select>
                    </div>
                    <div class="col-12 my-2">
                        <label class="text-muted">Incoming club position ({{confInfo.confincomingyear}})*</label>
                        <select class="form-control" v-model="register.club_role">
                            <option disabled value="0" selected>Please choose</option>
                            <option>OTHER</option> 
                            <option>NOT APPLICABLE</option> 
                            <option disabled>------</option>
                            <option>CLUB PRESIDENT</option>
                            <option>CLUB SECRETARY</option>
                            <option>CLUB PRESIDENT-ELECT</option>
                            <option>CLUB SECRETARY-ELECT</option>
                            <option>CLUB DIRECTOR/OFFICER</option>
                            <option v-show="confInfo.type=='rotary'">ASSISTANT GOVERNOR</option>
                            <option v-show="confInfo.type=='rotary'">ASSISTANT GOVERNOR-ELECT</option>
                            <option>ASSISTANT DISTRICT ROTARACT REPRESENTATIVE</option>
                            <option>ASSISTANT DISTRICT ROTARACT REPRESENTATIVE-ELECT</option>
                            <option>DISTRICT OFFICER</option>
                            <option>DISTRICT OFFICER ELECT</option>   
                        </select>
                    </div>
                    <div class="col-12" v-show="confInfo.confvirtual===false">
                        <div class="row">
                    <div class="col-12 my-2">
                        <label class="text-muted">Shirt/Polo size*</label>
                        <select class="form-control" v-model="register.tshirt">
                            <option disabled value="0">Please choose</option>
                            <option >X-SMALL</option>
                            <option >SMALL</option>
                            <option >MEDIUM</option>
                            <option >LARGE</option>
                            <option >X-LARGE</option>
                            <option >2X-LARGE</option>
                            <option >3X-LARGE</option>
                        </select>
                    </div>
                    <div class="col-12 my-2">
                        <label class="text-muted">Conference booklet*</label>
                        <select class="form-control" v-model="register.booklet">
                            <option disabled value="0">Please choose</option>
                            <option >DIGITAL</option>
                            <option >HARDCOPY</option>
                            <option >NONE</option>
                        </select>
                    </div>
                    <div class="col-12 my-2">
                        <label class="text-muted">Dietary requirements*</label>
                        <select class="form-control" v-model="register.dietsubject">
                            <option disabled value="0">Please choose</option>
                            <option>NONE</option>
                            <option>ALLERGIES</option>
                            <option>DIABETIC</option>
                            <option>LACTOSE INTOLERANT</option>
                            <option>NO PORK</option>
                            <option>NO RED MEAT</option>
                            <option>NO SEAFOOD</option>
                            <option>NO SHELLFISH</option>
                            <option>VEGETARIAN</option>
                            <option>OTHER</option>
                            
                        </select>
                        <textarea  rows="3" class="form-control my-2" placeholder="Please provide details" v-model="register.dietdetails" v-show="register.dietsubject && register.dietsubject=='OTHER'"/>
                    </div>
                    <div class="col-12 my-2">
                        <label class="text-muted">Special requirements*</label>
                        <select class="form-control" v-model="register.reqsubject">
                            <option disabled value="0">Please choose</option>
                            <option >NONE</option>
                            <option>ASSISTED LISTENING DEVICES</option>
                            <option>BRAILLE MATERIALS</option>
                            <option>WHEELCHAIR</option>
                            <option>OTHER</option>
                        </select>
                        <textarea rows="3" class="form-control my-2" placeholder="Please provide details" v-model="register.reqdetails" v-show="register.reqsubject && register.reqsubject=='OTHER'"/>
                    </div>
					<div class="col-12 my-2">
                        <hr size="1" />
                        <h5>Vaccination Card Upload</h5>
                        <label class="text-muted">Covid-19 vaccination certificate*</label>
                        <VaxCardUploader type="vaxcard" @uploadComplete="updateVaxInfo" />
                    </div>
                    <div class="col-12 my-2">
                        <hr size="1" />
                        <h5>Emergency Contact Information</h5>
                        <label class="text-muted">Emergency contact full name*</label>
                        <input type="text" class="form-control" v-model="register.ename" />
                    </div>
                    <div class="col-12 my-2">
                        <label class="text-muted">Emergency contact phone number*</label>
                        <input type="text" class="form-control" v-model="register.ephone" />
                    </div>
                    <div class="col-12 my-2">
                        <label class="text-muted">Relation to emergency contact*</label>
                        <select class="form-control" v-model="register.erelation">
                            <option value="0" disabled selected>Please choose</option>
                            <option>SPOUSE</option>
                            <option>PARENT</option>
                            <option>SIBLING</option>
                            <option>CHILD</option>
                            <option>OTHER</option>
                        </select>
                        <hr size="1" />
                    </div>
                        </div>
                    </div>
                    <div class="col-12 my-2" v-show="confInfo.confpayment">
                        <h5>Payment Information</h5>
                        <label class="text-muted">Cardholder's full name*</label><input type="text" class="form-control mb-3" v-model="cardholder.fullname" />
                        <label class="text-muted">Cardholder's email address*</label><input type="text" class="form-control mb-3" v-model="cardholder.emailaddress" />
                        <label class="text-muted">Cardholder's mobile number*</label><input type="text" class="form-control mb-3" v-model="cardholder.phone" />
                        <input type="hidden" value="" name="stripeAmount" id="stripeAmount" v-model="stripeAmount">
                        <fieldset>
                            <div class="">  
                                <label class="text-muted">Card number</label>
                                    <div class="small"><em>This charge will appear on your credit card statment as 'SOCAISLAND*{{descriptor.toUpperCase()}}'.</em></div>
                                <div id="card-element" class="form-control my-2"></div>
                            
                                <!-- Used to display form errors. -->
                                <div id="card-errors" class="my-2" role="alert" style="color:#ff0000;"> </div>
                            </div>
                        </fieldset> 
                    </div>
                    <div class="col-12 my-2">
                        <hr size="1" />
                    </div>

                    <div class="col-12 my-3">
                        <label>
                            <input type="checkbox" value="true" v-model="register.emailConsent" /> I consent to receive emails from {{confInfo.confhost}}.* 
                        </label>
                    </div>
                    <div class="col-12 my-1">
                        <label>
                            <input type="checkbox" value="true" v-model="register.dataConsent" /> I agree to allow {{confInfo.confhost}} to store and process my personal data.*
                        </label>
                    </div>
					<div class="col-12 my-1">
                        <label>
                            <input type="checkbox" value="true" v-model="register.refundConsent" /> I understand the conference registration fee is non-refundable, however should the in-person component of the 2022 district 7030 conference be cancelled due to Barbados Government laws or protocols, which may come into force subsequent to your registration, and which restrict the organisers' ability to host the in-person conference, the organisers will issue a refund of your registration fee.  The refund will be processed to the credit card used at the time of your registration, less any bank or processing fees which may have been paid. All refunds are at the discretion of the conference organisers.*
                        </label>
                    </div>
                    <div class="col-12 my-2">
                        <small>
                            By submitting this form you are agreeing to {{confInfo.confhost}}'s <a href="#!" target="_legal">Terms and Privacy Policy</a>
                        </small>
                    </div>
                    <div class="col-12 my-1">
                        <button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid||isBusy" @click="btnPayContinueClick" v-if="confInfo.confpayment">
                            <span v-show="!isBusy">Pay and continue</span>
                            <div class="spinner-border text-light" role="status" v-show="isBusy">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </button>
                        
                        <button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid||isBusy" @click="btnContinueClick" v-if="!confInfo.confpayment">
                            <span v-show="!isBusy">Continue</span>
                            <div class="spinner-border text-light" role="status" v-show="isBusy">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </button>
                    </div>
                </div>
                <div class="col-12 my-1" align="center">
                    <button class="btn btn-link" @click="$router.push(`/${confId}`)">
                        Cancel registration
                    </button>
                </div>
            </div>
            <div class="col-12 col-lg-3 "></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="//js.stripe.com/v3/"></script>
<script>
import VaxCardUploader from '../components/VaxCardUploader.vue'
const fb = require("../firebaseConfig")
export default {
    name: "AddRegistration",
    components: { VaxCardUploader },
    computed:{
        userProfile(){
            return this.$store.state.userProfile
        },
        confId(){
            return this.$store.state.confId
        },
        confName(){
            return this.$store.state.confName
        },
        confInfo(){
            return this.$store.state.confInfo
        },
        API_URL(){
            return this.$store.state.API_URL
        },
        isFormValid(){
            if(!this.confticket) return false
            if(this.registerType=="2"){
                if(!this.register.fname) return false
                if(!this.register.lname) return false
                if(!this.register.email) return false
                if(!this.register.phone) return false
                if(!this.register.gender) return false
                if(!this.register.country) return false
                if(!this.register.club) return false
                if(!this.register.club_role) return false
            }

            if(this.confInfo.confpayment===true){
                if(!this.cardholder.fullname) return false
                if(!this.cardholder.emailaddress) return false
                if(!this.cardholder.phone) return false
            }

            if(this.confInfo.confvirtual===false){
                if(!this.register.tshirt) return false
                if(!this.register.booklet) return false
                if(!this.register.ename) return false
                if(!this.register.ephone) return false
                if(!this.register.erelation) return false
                if(!this.register.emailConsent) return false
				if(!this.register.refundConsent) return false
                if(!this.register.dataConsent) return false
                if(!this.register.dietsubject) return false
                if(!this.register.reqsubject) return false
                if(this.register.dietsubject && this.register.dietsubject=="OTHER" && !this.register.dietdetails) return false
                if(this.register.reqsubject && this.register.reqsubject=="OTHER" && !this.register.reqdetails) return false 
            }

			if(!this.register.imgFile) return false
            if(!this.register.imgFileName) return false

            if(!this.register.emailConsent) return false
            if(!this.register.dataConsent) return false
            
            return true
        }
    },
    data(){
        return{
            isBusy: false,
            registerType:"0",
            register:{},
            cardholder:{},
            confTickets:[],
            confticket:{},
            showForm:true,
            descriptor:"ROTARY7030",
            stripeAmount:0,
            fees:0,
            clientSecret:"",
        }
    },
    methods:{
		updateVaxInfo(vaxInfo){
			this.register.imgFile = vaxInfo.imgFile;
			this.register.imgFileName = vaxInfo.imgFileName;
			//console.log(vaxInfo);
		},
        async btnPayContinueClick(){
            this.isBusy = true
            const trxnId = Math.floor(Date.now()/1000)
            const tktPrice = Number(this.confticket.price)+0.50
            this.stripeAmount= Math.trunc((tktPrice/0.935)*100)

            if(this.clientSecret==""){
                if(this.stripeAmount <1) return false
                let striperesponse = await fetch(`${this.API_URL}/stripe/create/${trxnId}!${this.stripeAmount}!${encodeURI(this.cardholder.fullname)}!${encodeURI(this.confticket.name)}!${encodeURI(this.cardholder.emailaddress)}!USD!${encodeURI(this.confId)}!${this.descriptor}`).then((response)=> {
                    return response.json()
                })
                this.clientSecret = striperesponse.client_secret
                this.pytintent = striperesponse.payment_intent
            }
            console.log(this.clientSecret, this.pytintent)
            if(!this.clientSecret) {
                this.isBusy = false
                this.clientSecret = ""
                return false 
            }
            this.stripe.confirmCardPayment(this.clientSecret,
                {
                    payment_method: {
                    card: this.card,
                    billing_details: {
                        name: this.cardholder.fullname,
                        email: this.cardholder.emailaddress,
                        phone: this.cardholder.mobile,
                    },
                },
            }).then(async (result) =>{
                if (result.error) {
                    document.getElementById('card-errors').textContent = result.error.code + " - " + result.error.decline_code
                    this.isBusy = false
                    this.clientSecret = ""
                } else{
                    console.log('The payment has been processed!')
                    this.btnContinueClick(trxnId, "PAID")
                    this.clientSecret = ""
                }
            })

        },
        btnContinueClick(trxnId, trxnStatus){
            const orderId = trxnId ? trxnId : Math.floor(Date.now()/1000)
            console.log("order id: ", orderId)

            this.register.UUID = this.userProfile.UUID
            this.register.confeventid = this.confId
            this.register.confeventname = this.confName
            this.register.confticket = this.confticket.name
            this.register.confticketid = this.confticket.id
            this.register.confticketprice = this.confticket.price
            this.register.stripeAmount = this.stripeAmount
            this.register.orderid = orderId
            this.register.added = new Date()
            this.register.status = trxnStatus ? trxnStatus : "REGISTERED"

            if(this.registerType=="1"){
                this.register.fname = this.userProfile.fname
                this.register.lname = this.userProfile.lname
                this.register.email = this.userProfile.email
                this.register.phone = this.userProfile.phone
                this.register.gender = this.userProfile.gender.toUpperCase()
                this.register.country = this.userProfile.country.toUpperCase()
            }

            fb.ordersCollection.doc(String(orderId)).set(this.register).then(()=>{
                fb.adminEmailCollection.add({
                    to:this.confInfo.confemaillist,
                    message:{
                        subject: `New conference registration - ${this.register.fname} ${this.register.lname} - ${this.register.club}`,
                        html:`<h4>Congratulations Conference Team!</h4>
                        <p>You"ve just received a new registration for your event.</p>
                        <p>&nbsp;</p>
                        <p>Name - ${this.register.fname} ${this.register.lname}</p>
                        <p>Club - ${this.register.club}</p>
                        <p>Registration Id - ${orderId}</p>
                        <p>Ticket - ${this.confticket.name}</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p><hr/></p>
                        <p style="font-size:10px;">${this.confInfo.confhost}</p>`,
                    },
                }).then(()=>{
                })
                fb.adminEmailCollection.add({
                    to:[`${this.register.email}`],
                    message:{
                        subject: `${this.register.fname} ${this.register.lname} - Event Registration - ${orderId}`,
                        html:`<p>${this.register.fname},</p>
                        ${this.confInfo.confmessage}
                        <p style="font-size:10px;">${this.confInfo.confhost}</p>`,
                    },
                }).then(()=>{
                }) 
                this.showForm = false
                window.scrollTo(0,0)
            }).catch((error) => {
                console.error("Error writing document: ", error);
            })
        }
    },
    mounted(){
        let confId = this.$route.params.id
        this.$store.dispatch("fetchConfProfile", confId)
        fb.confticketsCollection.where("eventid", "==", confId).onSnapshot((querySnapshot)=>{
            let confTickets = []
            querySnapshot.forEach((doc)=>{
				if(doc.data().ispublic) confTickets = [...confTickets, {id: doc.id, data: doc.data()}]
            })
            this.confTickets = confTickets
        })

        this.stripe = Stripe("pk_live_NO5i9A0rJetFGqZ99mLPeSpP") //pk_test_itCmziCcsavym8T71gROTOhj  pk_live_NO5i9A0rJetFGqZ99mLPeSpP
        var elements = this.stripe.elements()
        let style = {
            base: {
                color: '#32325d',
                fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '1.15em',
                '::placeholder': {
                        color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        }

        // Create an instance of the card Element.
        this.card = elements.create('card', {style: style})

        // Add an instance of the card Element into the `card-element` <div>.
        this.card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        let displayError = document.getElementById('card-errors')
        this.card.addEventListener('change', (event)=> {
            this.isBusy = false
            if (event.error) {
                displayError.textContent = event.error.message
            } else {
                displayError.textContent = ''
            }
        })
    },
}
</script>